import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import * as SessionInfo from "./SessionInfo";
import * as Feedback from "./feedback/Feedback";
export function timeout(ms) {
  return function (value) {
    return new Promise(function (resolve) {
      return setTimeout(function () {
        return resolve(value);
      }, ms);
    });
  };
}

/**
 * Copy html into clipboard as formatted text.
 * Supported by all browsers ;owever, IE 11 will ask for confirmation on that action.
 *
 * @param html text to be formatted and copied to clipboard
 */
export function copyFormattedHtmlToClipboard(html) {
  var i;

  // Create container for the HTML
  var container = document.createElement("div");
  container.innerHTML = html;

  // Hide element
  container.style.position = "fixed";
  container.style.pointerEvents = "none";
  container.style.opacity = 0;

  // Detect all style sheets of the page
  var activeSheets = Array.prototype.slice.call(document.styleSheets).filter(function (sheet) {
    return !sheet.disabled;
  });

  // Mount the container to the DOM to make `contentWindow` available
  document.body.appendChild(container);

  // Copy to clipboard
  window.getSelection().removeAllRanges();
  var range = document.createRange();
  range.selectNode(container);
  window.getSelection().addRange(range);

  // Do the copying itself. This is actually a multi-step process: Chrome will copy text as it sees it, with applied CSS styles,
  // while other browsers will copy it with the browser's default styles. Therefore we will disable all user styles before copying
  // to get the most consistent result possible.
  //
  // Before we do this, we prematurely execute the copy command. This is a hack for IE11: In this browser, the copying must be manually
  // confirmed once. Until the user clicked the "Confirm" button, IE users would see the page without any styles. To avoid this, we copy
  // first, wait for confirmation, then disable the styles and copy again. That time we won't get a confirmation dialog since IE remembers
  // our last choice.
  document.execCommand("copy");

  // We actually disable the page's styles.
  for (i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = true;

  // Now we execute the copy command again.
  document.execCommand("copy");

  // We re-enable the stylesheets.
  for (i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = false;

  // Remove the container from the page's DOM.
  document.body.removeChild(container);
}
export function HtmlString(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      marginBottom: 10
    },
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
}

/**
 * Issues a fetch request. Request is JSON, response is JSON.
 *
 * @param url This parameter should only carry the piece of URL after the base portion e.g. '/application'
 * @param params Optional fetch request parameters
 */
export function fetchJsonDataUsingJson(_x, _x2) {
  return _fetchJsonDataUsingJson.apply(this, arguments);
}

/**
 * Issues a fetch request. Request is JSON, response is NOT JSON.
 *
 * @param url This parameter should only carry the piece of URL after the base portion e.g. '/application'
 * @param params Optional fetch request parameters
 */
function _fetchJsonDataUsingJson() {
  _fetchJsonDataUsingJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", fetchData(url, params, true, true));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchJsonDataUsingJson.apply(this, arguments);
}
export function fetchNonJsonDataUsingJson(_x3, _x4) {
  return _fetchNonJsonDataUsingJson.apply(this, arguments);
}

/**
 * Issues a fetch request. Request is NOT JSON, response is JSON.
 *
 * @param url This parameter should only carry the piece of URL after the base portion e.g. '/application'
 * @param params Optional fetch request parameters
 */
function _fetchNonJsonDataUsingJson() {
  _fetchNonJsonDataUsingJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", fetchData(url, params, true, false));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchNonJsonDataUsingJson.apply(this, arguments);
}
export function fetchJsonDataUsingNonJson(_x5, _x6) {
  return _fetchJsonDataUsingNonJson.apply(this, arguments);
}

/**
 * Issues a fetch request. Request is NOT JSON, response is NON JSON.
 *
 * @param url This parameter should only carry the piece of URL after the base portion e.g. '/application'
 * @param params Optional fetch request parameters
 */
function _fetchJsonDataUsingNonJson() {
  _fetchJsonDataUsingNonJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url, params) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", fetchData(url, params, false, true));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchJsonDataUsingNonJson.apply(this, arguments);
}
export function fetchNonJsonDataUsingNonJson(_x7, _x8) {
  return _fetchNonJsonDataUsingNonJson.apply(this, arguments);
}

/**
 * Issues a fetch request.
 * @param url This parameter should only carry the piece of URL after the base portion e.g. '/application'
 * @param params Optional fetch request parameters
 * @param isJsonRequest By default it's assumed that the request is json. Pass in [false] to avoid sending the json content type header.
 * @param isJsonResponse By default it's assumed that the response is json and it will be parsed. Pass in [false] to ovoid parsing the response.
 * @returns {Promise<any>}
 */
function _fetchNonJsonDataUsingNonJson() {
  _fetchNonJsonDataUsingNonJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url, params) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", fetchData(url, params, false, false));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchNonJsonDataUsingNonJson.apply(this, arguments);
}
export function fetchData(_x9, _x10) {
  return _fetchData.apply(this, arguments);
}

/**
 * Returns an error message given the failed response.
 * Assumes that the response carries an error message in plain text
 * (not json or html).
 *
 * @param response failed response carrying error text message
 * @param defaultErrorMessage default error message which will prefix the text extracted from the response
 * @returns {Promise<string>}
 */
function _fetchData() {
  _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url, params) {
    var isJsonRequest,
      isJsonResponse,
      defaultParams,
      response,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          isJsonRequest = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
          isJsonResponse = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : true;
          defaultParams = {};
          if (isJsonRequest !== false) {
            defaultParams.headers = {
              "Content-Type": "application/json"
            };
          }
          params = _objectSpread(_objectSpread({}, defaultParams), params);
          _context5.next = 7;
          return fetch(getBaseUrl() + url, params).then(function (response) {
            var containsFeedback = response.headers.get("X-EaiFeedbackMessages");
            if (containsFeedback) {
              Feedback.refresh();
            }
            var sessionDirty = response.headers.get("X-EaiSessionDirty");
            if (sessionDirty) {
              SessionInfo.refresh();
            }

            //
            // Error scenario
            if (!response.ok) {
              console.log("Request failed:");
              console.table(response);
              if (response.status === 401) {
                SessionInfo.clear();
              }
              throw response;
            }
            return response;
          });
        case 7:
          response = _context5.sent;
          if (!(isJsonResponse !== false)) {
            _context5.next = 10;
            break;
          }
          return _context5.abrupt("return", response.json());
        case 10:
          return _context5.abrupt("return", response);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fetchData.apply(this, arguments);
}
export function getErrorMessage(_x11, _x12) {
  return _getErrorMessage.apply(this, arguments);
}
function _getErrorMessage() {
  _getErrorMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response, defaultErrorMessage) {
    var errorMessage;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return response.text();
        case 3:
          errorMessage = _context6.sent;
          _context6.next = 9;
          break;
        case 6:
          _context6.prev = 6;
          _context6.t0 = _context6["catch"](0);
          console.log("Error parsing text error message", _context6.t0);
        case 9:
          if (!(!defaultErrorMessage && !errorMessage)) {
            _context6.next = 11;
            break;
          }
          return _context6.abrupt("return", "Internal Server Error. HTTP code: " + response.status);
        case 11:
          return _context6.abrupt("return", defaultErrorMessage + (errorMessage ? " " + errorMessage : ""));
        case 12:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 6]]);
  }));
  return _getErrorMessage.apply(this, arguments);
}
export function isDev() {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
}

/**
 * Returns base url for all requests.
 * @returns {string}
 */
export function getBaseUrl() {
  if (isDev()) {
    // dev code
    return window.location.protocol + "//" + window.location.hostname + ":8080/";
  } else {
    // production code
    return "";
  }
}
export function createFormBody(params) {
  var formBody = [];
  for (var property in params) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(params[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return formBody;
}
export function extractFileNameFromResponse(response) {
  var contentDispositionValue = response.headers.get("Content-Disposition");
  var filename = "";
  if (contentDispositionValue && contentDispositionValue.indexOf("attachment") !== -1) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(contentDispositionValue);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }
  return filename;
}

/**
 * This hook makes it easy to detect when the user is pressing a specific key on their keyboard
 * @param targetKey key to monitor, eg.  useKeyPress("h")
 */
export function useKeyPress(targetKey) {
  // State for keeping track of whether key is pressed
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    keyPressed = _React$useState2[0],
    setKeyPressed = _React$useState2[1];

  // If pressed key is our target key then set to true
  function downHandler(_ref2) {
    var key = _ref2.key;
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  // If released key is our target key then set to false
  var upHandler = function upHandler(_ref3) {
    var key = _ref3.key;
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };
  // Add event listeners
  React.useEffect(function () {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    // Remove event listeners on cleanup
    return function () {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount
  return keyPressed;
}
export function abbreviateString(str, maxLength) {
  if (str.length > maxLength) {
    return str.substring(0, maxLength - 3) + "...";
  } else {
    return str;
  }
}